var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import classnames from 'classnames';
import { AnimatePresence, motion } from 'framer-motion';
import { tokens } from '@servicetitan/tokens/core';
import { Overlay } from '../../internal/Overlay';
import { wrapWithComponent } from '../../utilities/wrapWithComponent';
import { useFocusTrap } from '../../hooks/useFocusTrap';
import { TakeoverHeader } from './TakeoverHeader';
import { TakeoverSection } from './TakeoverSection';
import { TakeoverFooter } from './TakeoverFooter';
export const Takeover = (_a) => {
    var { actions, animate = false, backLabel, children, className, contentWrapperClass, focusTrapOptions, footer, footerAlign = TakeoverFooter.defaultProps.align, onBack, onClose, open = true, portal = true, sectioned, theme = TakeoverHeader.defaultProps.theme, title } = _a, props = __rest(_a, ["actions", "animate", "backLabel", "children", "className", "contentWrapperClass", "focusTrapOptions", "footer", "footerAlign", "onBack", "onClose", "open", "portal", "sectioned", "theme", "title"]);
    React.useEffect(() => {
        if (open) {
            document.body.classList.add('Takeover--is-open');
        }
        else {
            const otherOpenTakeovers = document.getElementsByClassName('Takeover').length > 0;
            if (otherOpenTakeovers) {
                document.body.classList.add('Takeover--is-open');
            }
        }
        return () => document.body.classList.remove('Takeover--is-open');
    }, [open]);
    // Focus trapping
    const takeoverRef = useFocusTrap(Object.assign({ autoFocusContainer: true, disabled: !open }, focusTrapOptions));
    const headerProps = {
        actions,
        backLabel,
        onBack,
        onClose,
        theme,
        title,
    };
    const footerProps = {
        align: footerAlign,
        children: footer,
    };
    const TakeoverClasses = classnames('Takeover', className, `Takeover--${theme}`);
    const contentWrapperClasses = classnames('TakeoverContent', contentWrapperClass);
    const content = !sectioned
        ? wrapWithComponent(children, TakeoverSection)
        : children;
    const duration = parseInt(tokens.durationStandard, 10) / 1000; // '200ms' -> 0.2
    const framerAnimation = {
        initial: { opacity: 0, y: 50 },
        animate: { opacity: 1, y: 0 },
        exit: { opacity: 0, y: 50 },
        transition: { type: 'easeInOut', duration },
    };
    const Animate = animate ? AnimatePresence : React.Fragment;
    const TakeoverEl = animate ? motion.div : 'div';
    const TakeoverProps = Object.assign(Object.assign({ className: TakeoverClasses, ref: takeoverRef }, (animate && framerAnimation)), props);
    return (React.createElement(Overlay, { portal: portal, animate: animate, open: open },
        React.createElement(Animate, null, open && (React.createElement(TakeoverEl, Object.assign({ "data-anvil-component": "Takeover" }, TakeoverProps),
            React.createElement(TakeoverHeader, Object.assign({}, headerProps)),
            React.createElement("div", { className: contentWrapperClasses }, content),
            React.createElement(TakeoverFooter, Object.assign({}, footerProps)))))));
};
Takeover.Header = TakeoverHeader;
Takeover.Section = TakeoverSection;
Takeover.Footer = TakeoverFooter;
//# sourceMappingURL=Takeover.js.map